// this file added by Bearer Web Developer
import { Button } from "@mui/material";
import styles from './editOriginLocation.module.scss';
import React from "react";
import { useAppState } from "../../../../states/app-state";
import { observer } from "mobx-react-lite";
 
const EditOriginLocation: React.FC = observer(() => {

    const appState = useAppState();
    const { setDefaultOriginFormOpen } = appState.favouritePlaces;
    const handleDefaultOriginForm = () => {
        // open defaultOriginForm
        setDefaultOriginFormOpen(true)
    };

    // modified by Bearer Web Developer start
    return (
        <>
            
            <div className={styles.favourite_places} onClick={handleDefaultOriginForm}>
                <div className={styles.favourite_place_info}>
                    <div className={styles.location_favourite_place}>
                        <img src="/edit-location-grey.svg" alt="edit location" />
                    </div>
                    <div className={styles.list_item_text}>
                        <h6>Set your default origin location</h6>
                        <p>Click here to add the address</p>
                    </div>
                </div>
                <Button>
                    <img src="/edit-location-pen.svg" alt="edit" />
                </Button>
            </div>
        </>
    )
    // modified by Bearer Web Developer end
})
export default EditOriginLocation;